<template>
  <div class="nodata">
    <div class="nodata_warpper">
      <img src="@/assets/images/empty.png" />
      <span class="img-span">暂无数据</span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {};
  },
  components: {

  },
  created () { },
  mounted () {

  }
};
</script>
<style>
.nodata {
  text-align: center;
}
.nodata_warpper img {
  width: 150px;
}

.nodata_warpper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.img-span {
  font-size: 18px;
  color: #cfcbc9;
  font-weight: bold;
  /* position: relative;
  bottom: 30px; */
}
</style>
